import { useAreaHereOnce } from "@/lib/hooks/envoyArea";

/**
 * Tells envoy where the browser is, once a browser session, for the
 * person signed in. Draws nothing and says nothing on a failure: the
 * envoy's area is a background nicety, shown on the envoy page.
 */
export default function AreaHere({ userId }: { userId: string }) {
    useAreaHereOnce(userId);
    return null;
}
